var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 113,
    viewBox: "0 0 136 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 44.5034C137.669 91.4202 99.4457 112.503 69.3092 112.503C39.1727 112.503 0 87.1626 0 60.1731C0 33.1835 7.19355 16.3768 37.5085 5.96953C67.8235 -4.43778 130.331 -2.41335 134 44.5034Z",
    fill: "#FAFAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.75 32.7604C81.8772 31.6332 83.4059 31 85 31C85.7893 31 86.5709 31.1555 87.3001 31.4575C88.0293 31.7596 88.6919 32.2023 89.25 32.7604C89.8081 33.3185 90.2508 33.9811 90.5529 34.7103C90.8549 35.4395 91.0104 36.2211 91.0104 37.0104C91.0104 37.7997 90.8549 38.5813 90.5529 39.3105C90.2508 40.0397 89.8081 40.7023 89.25 41.2604L53.8333 76.6771L42.5 79.5104L45.3333 68.1771L80.75 32.7604Z",
    fill: "#E6E5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1667 65.3437L53.8333 76.6771L42.5 79.5104L45.3333 68.1771L49.7604 63.75L65.1667 65.3437Z",
    fill: "#8E8CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8114 79.0745C75.3894 77.7102 68.3156 76.4101 60.2886 81.7614C59.6376 82.1954 58.758 82.0195 58.324 81.3685C57.89 80.7175 58.0659 79.8379 58.7169 79.4039C67.6899 73.422 75.7828 74.8168 79.8607 76.4426C83.3835 77.8471 85.6467 78.4599 87.4819 78.4599C89.2302 78.4599 90.7285 77.9011 92.7187 76.5787C93.3704 76.1457 94.2497 76.3229 94.6827 76.9746C95.1157 77.6262 94.9384 78.5055 94.2868 78.9385C92.027 80.4401 89.9836 81.2933 87.4819 81.2933C85.0671 81.2933 82.372 80.4941 78.8114 79.0745Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.b98729fb5e136462debde5087c07e12a.svg";
export { ForwardRef as ReactComponent };